/**
 * Layout steps of the restaurant dashboard, from the page's own width
 * instead of the window's: the docked «Asistente» panel takes 400 px of a
 * desktop window, so a 1440 px window leaves the page about 770 px (V2
 * guidelines: tiers come from the pane's width). Each step keeps the
 * geometry the viewport rules gave a page of that width with the drawer
 * open and no panel.
 */

/** Two metric columns and the regular padding (below: phones). */
export const DASHBOARD_SM_MIN = 560;
/** Order status and quick actions side by side. */
export const DASHBOARD_MD_MIN = 720;
/** Three metric columns; messages move to a right column. */
export const DASHBOARD_LG_MIN = 900;
/** The right column takes a quarter of the width; the widest padding. */
export const DASHBOARD_XL_MIN = 1000;

export interface IDashboardLayoutClasses {
  'is-sm': boolean;
  'is-md': boolean;
  'is-lg': boolean;
  'is-xl': boolean;
}

/** The step classes (mobile first, like min-width queries) for a page `width` px wide. */
export function dashboardLayoutClasses(width: number): IDashboardLayoutClasses {
  return {
    'is-sm': width >= DASHBOARD_SM_MIN,
    'is-md': width >= DASHBOARD_MD_MIN,
    'is-lg': width >= DASHBOARD_LG_MIN,
    'is-xl': width >= DASHBOARD_XL_MIN,
  };
}
